/**
 * BULLET · GRÁFICOS RÁPIDOS
 *
 * Bullet usa o mesmo compositor modular dos demais FastCharts. Uma única
 * instância pode agrupar várias métricas, cada uma com sua própria escala,
 * bands, valor e meta.
 *
 * Regras demonstradas aqui:
 * - um `series[]` representa um Bullet do grupo;
 * - cada série pode sobrescrever `min`, `max`, `ticks` e `bands` em
 *   `series[].options.fast`;
 * - as bandas definem apenas os thresholds; a paleta default vem do tema;
 * - valor atual em `series[].value`;
 * - meta em `series[].target`;
 * - `unit` e `dataLabels` continuam pertencendo à série;
 * - `chart.update(value, seriesIndex)` atualiza uma métrica;
 * - `chart.update([a, b, c])` atualiza o grupo inteiro sem remontar o chart.
 */

const revenueFast = {
  min: 0,
  max: 300,
  ticks: [0, 50, 100, 150, 200, 250, 300],
  bands: [
    { from: 0 },
    { from: 150 },
    { from: 225 }
  ]
};

const profitFast = {
  min: 0,
  max: 30,
  ticks: [0, 5, 10, 15, 20, 25, 30],
  bands: [
    { from: 0 },
    { from: 20 },
    { from: 25 }
  ]
};

const customersFast = {
  min: 0,
  max: 2250,
  ticks: [0, 500, 1000, 1500, 2000, 2250],
  bands: [
    { from: 0 },
    { from: 1400 },
    { from: 2000 }
  ]
};

export const bulletGrouped = {
  element: 'chart',
  type: 'bullet',
  skin: 1,
  title: 'Metas',
  chartBox: true,
  cols: 3,
  style: { alignSelf: 'start' },

  series: [
    {
      subtitle: 'Receita YTD',
      name: 'Revenue',
      unit: 'US$ mil',
      value: 275,
      target: 250,
      options: {
        fast: revenueFast,
        dataLabels: { format: '{value}', fixed: 0 }
      }
    },
    {
      subtitle: 'Margem',
      name: 'Profit',
      unit: '%',
      value: 22,
      target: 27,
      options: {
        fast: profitFast,
        dataLabels: { format: '{value}', fixed: 0 }
      }
    },
    {
      subtitle: 'Novos clientes',
      name: 'NewCustomers',
      unit: '',
      value: 1650,
      target: 2100,
      options: {
        fast: customersFast,
        dataLabels: { format: '{value}', fixed: 0 }
      }
    }
  ]
};

export const bulletQuickCharts = [bulletGrouped];

export default bulletQuickCharts;
